<template>
<div class="row m-0 p-0">
	<div
		v-if="[
			ElectricMeter.versions.nikDlms,
			ElectricMeter.versions.impulseInput,
			ElectricMeter.versions.gama100G1m,
			ElectricMeter.versions.gama100G1b
		].includes(electricMeterType)"
		class="col-xxl-3 p-0 m-0"
	>
		<tile-vidget
			title="Активна енергія повна"
			class="overflow-x-hidden overflow-y-hidden"
			:style="electricMeterConnection ? '' : 'filter: grayscale(100%);'"
		>
			<div class="row m-0 mt-auto p-0">
				<div class="col mx-0 ps-2 text-center metric-value-text">
					<span class="fs-1">
						{{ fullActiveEnergy }}
					</span>
				</div>
			</div>
			<div class="row m-0 mb-3 p-0 mt-auto">
			</div>
		</tile-vidget>
	</div>
	<div
		v-if="
			station?.electricMeterIsSeparateUnit
			&& station.electricMeter.isPresentActiveEnergyTarifs
		"
		class="col-xxl-3 p-0 m-0 g-0"
	>
		<tile-vidget
			title="Поточні показники"
			class="overflow-x-hidden overflow-y-hidden"
			:style="electricMeterConnection ? '' : 'filter: grayscale(100%);'"
		>
			<div class="row m-0 p-0">
				<div class="col-6 mx-0 ps-2 text-start metric-name-text">Енергія&nbsp;по&nbsp;тарифу&nbsp;1</div>
				<div class="col-6 mx-0 pe-2 text-end metric-value-text">
					{{ numberToKnumber(electricMeterMetric(`${`${ElectricMeter.metricKeys.activeEnergyFullApPam}_1`}`), 1) }} кВт⋅год
				</div>
			</div>
			<div class="row m-0 p-0">
				<div class="col-6 mx-0 ps-2 text-start metric-name-text">Енергія&nbsp;по&nbsp;тарифу&nbsp;2</div>
				<div class="col-6 mx-0 pe-2 text-end metric-value-text">
					{{ numberToKnumber(electricMeterMetric(`${`${ElectricMeter.metricKeys.activeEnergyFullApPam}_2`}`), 1) }} кВт⋅год
				</div>
			</div>
			<div class="row m-0 p-0">
				<div class="col-6 mx-0 ps-2 text-start metric-name-text">Енергія&nbsp;по&nbsp;тарифу&nbsp;3</div>
				<div class="col-6 mx-0 pe-2 text-end metric-value-text">
					{{ numberToKnumber(electricMeterMetric(`${`${ElectricMeter.metricKeys.activeEnergyFullApPam}_3`}`), 1) }} кВт⋅год
				</div>
			</div>
			<div class="row m-0 p-0">
				<div class="col-6 mx-0 ps-2 text-start metric-name-text">Енергія&nbsp;по&nbsp;тарифу&nbsp;4</div>
				<div class="col-6 mx-0 pe-2 text-end metric-value-text">
					{{ numberToKnumber(electricMeterMetric(`${`${ElectricMeter.metricKeys.activeEnergyFullApPam}_4`}`), 1) }} кВт⋅год
				</div>
			</div>
		</tile-vidget>
	</div>
	<div
		v-if="[
			ElectricMeter.versions.nikDlms,
			ElectricMeter.versions.impulseInput,
			ElectricMeter.versions.gama100G1m,
			ElectricMeter.versions.gama100G1b
		].includes(electricMeterType)"
		class="col-xxl-3 px-0 mx-0 g-0"
	>
		<tile-vidget
			class="overflow-x-hidden overflow-y-hidden"
			:style="electricMeterConnection ? '' : 'filter: grayscale(100%);'"
		>
			<div class="row m-0 mt-1 p-0">
				<div class="col-4 mx-0 ps-2 text-start metric-name-text">Тип/модель</div>
				<div v-if="station?.electricMeterIsSeparateUnit" class="col-8 mx-0 pe-2 text-end metric-value-text">
					{{ station.electricMeter.getMetricValue(ElectricMeter.metricKeys.model) }}
				</div>
				<div v-if="electricMeterType == ElectricMeter.versions.impulseInput" class="col-8 mx-0 pe-2 text-end metric-value-text">
					Імпульсний вхід сервісного модуля
				</div>
			</div>
			<div class="row m-0 mt-1 p-0">
				<div class="col-4 mx-0 ps-2 text-start metric-name-text">Час зчитування</div>
				<div v-if="station?.electricMeterIsSeparateUnit" class="col-8 mx-0 pe-2 text-end metric-value-text">
					{{ station.electricMeter.getMetricValue(ElectricMeter.metricKeys.lastConnection) == ''
						? '-'
						: dateTimeToString(station.electricMeter.getMetricValue(ElectricMeter.metricKeys.lastConnection), false)
					}}
				</div>
				<div v-if="electricMeterType == ElectricMeter.versions.impulseInput" class="col-8 mx-0 pe-2 text-end metric-value-text">
					{{ stationMetricTime(ServiceUnit.metricKeys.lastConnection, 'service') }}
				</div>
			</div>
			<div class="row m-0 mt-1 p-0">
				<div class="col-6 mx-0 ps-2 text-start metric-name-text">&nbsp;</div>
				<div class="col-6 mx-0 pe-2 text-end metric-value-text">&nbsp;</div>
			</div>
			<div class="row m-0 mt-1 p-0">
				<div class="col-6 mx-0 ps-2 text-start metric-name-text">&nbsp;</div>
				<div class="col-6 mx-0 pe-2 text-end metric-value-text">&nbsp;</div>
			</div>
			<div class="row m-0 mt-1 p-0">
				<div class="col-6 mx-0 ps-2 text-start metric-name-text">&nbsp;</div>
				<div class="col-6 mx-0 pe-2 text-end metric-value-text">&nbsp;</div>
			</div>
		</tile-vidget>
	</div>

	<div
		v-if="station?.electricMeterIsSeparateUnit"
		class="col-xxl-3 px-0 mx-0 g-0"
	>
		<div class="half-transparent-border m-1 px-2 half-transparent-border tile overflow-x-hidden overflow-y-hidden">
			<perform-survey-form
				:stationId="station.id"
				:isEnabled="accountStore.permissions.includes('dispatch_stations')"
				:show-station="false"
				format="short"
			/>
		</div>
	</div>
</div>
<span v-if="station?.electricMeterIsSeparateUnit">
	<div class="row mx-1 px-0 g-0 mt-3 fs-6">
		Поточні параметри
	</div>
	<easy-data-table
		class="data-table mx-1"
		table-class-name="customize-table"
		:key="rowsPerPage"
		:headers="tableHeaders"
		:items="tableRows"
		theme-color="rgb(198, 199, 200)"
		:rows-items="[10,20,40,100]"
		:rows-per-page="rowsPerPage"
		hide-footer
		rows-per-page-message="записів на сторінці"
		rows-of-page-separator-message=" з "
		:table-min-height="360"
		:table-height="tableHeight"
		:loading="isLoading"
		:no-hover="true"
		alternating
		buttons-pagination
	>
		<!-- If rows is empty -->
		<template #empty-message>
			Для станції не знайдено параметрів лічильника.<br>
			Причини:<br>
			* відсутні налаштування лічильника<br>
			* невірні налаштування, тому немає зв'язку з лічильником<br>
			* лічильник не відповідає на запити<br>
		</template>

		<template #loading>
			<div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
				<span class="visually-hidden">Loading...</span>
			</div>
		</template>

		<!-- Field name -->
		<template #item-_field="{ _field, type, show, }">
			<span
				v-if="show"
				:class="{'fw-bold': type == 'title_row'}"
			>
				{{ _field }}
			</span>
		</template>

		<!-- Field value -->
		<template #item-_value="{ _value, type, show, }">
			<span
				v-if="
					show
					&& ['meter_value', 'meter_values_group'].includes(type)
				"
			>
				{{ _value }}
			</span>
		</template>
	</easy-data-table>
</span>

<div class="row mx-1 px-0 g-0 mt-3 fs-6">
	Показання помісячно
</div>
<electric-meter-report-table
	class="mx-1 mb-2"
	:stationId="stationId"
/>
</template>


<script>
import TileVidget from "@/components/Vidgets/TileVidget"
import ElectricMeterReportTable from "./ElectricMeterReportTable.vue"
import PerformSurveyForm from './PerformSurveyForm.vue'
import {
	dateTimeToString,
	numberToKnumber,
	easyDataTableHeight,
	// easyDataTableRowsPerPage,
} from '@/helpers.js'
import { useAccontStore } from '@/stores/AccountStore.js'
import { useStationsStore } from '@/stores/StationsStore.js'
import { Station } from '@/models/station.js'
import { ServiceUnit } from '@/models/serviceUnit.js'
import { ElectricMeter } from "@/models/electricMeter.js"

export default {
	// Type description 46
	meter_status_bits: {
		0: { pos: 0, name: "Power suply error", nameUkr: "Помилка живлення" },
		1: { pos: 1, name: "Clock MC error", nameUkr: "Помилка годинника MC" },
		2: { pos: 2, name: "measurement error", nameUkr: "Помилка вимірювання" },
		4: { pos: 4, name: "memory chip 1 error", nameUkr: "Помилка пам'яті чипу 1" },
		5: { pos: 5, name: "memory chip 2 error", nameUkr: "Помилка пам'яті чипу 2" },
		6: { pos: 6, name: "program checksumm error", nameUkr: "Помилка контрольної суми програми" },
		8: { pos: 8, name: "temp is below min value", nameUkr: "Температура нижче мінімального значення" },
		9: { pos: 9, name: "err radio", nameUkr: "Помилка радіо" },
		10: { pos: 10, name: "err magn", nameUkr: "Помилка магніт" },
		11: { pos: 11, name: "DST", nameUkr: "DST" },
		12: { pos: 12, name: "Emergency tariff is operating", nameUkr: "Діє екстренний тариф" },
		13: { pos: 13, name: "energy registers damaged", nameUkr: "Пошкоджені енергетичні реєстри" },
		14: { pos: 14, name: "calibration metrology damaged", nameUkr: "Пошкоджено калібрування метрології" },
		15: { pos: 15, name: "paramerization damaged", nameUkr: "Пошкоджена параметризація" },
		16: { pos: 16, name: "clock failure", nameUkr: "Помилка годинника" },
		17: { pos: 17, name: "batary discharged", nameUkr: "Розряджена батарея" },
		24: { pos: 24, name: "load relay switched off", nameUkr: "Вимкнено реле навантаження" },
		25: { pos: 25, name: "Consumer disconection relay switched off", nameUkr: "Вимкнуто реле відключення споживача" },
		28: { pos: 28, name: "Err radio is indicating", nameUkr: "Помилка радіо на індикаторі" },
		29: { pos: 29, name: "Err Magn is indicating", nameUkr: "Помилка магніт на індикатирі" },
		30: { pos: 30, name: "Debt is indicating", nameUkr: "Борг на індикаторі" }
	},

	// Type description 47
	power_line_status_bits: {
		0: { pos: 0, size: 2, name: "Active quadrant", nameUkr: "Активний квадрант" },
		2: { pos: 2, name: "amperage inequality", nameUkr: "Нерівність струмів" },
		3: { pos: 3, name: "Incorrect phase sequence", nameUkr: "Невірна послідовність фаз" },
		8: { pos: 8, name: "channel A reversed", nameUkr: "Канал A перевернутий" },
		9: { pos: 9, name: "channel B reversed", nameUkr: "Канал B перевернутий" },
		10: { pos: 10, name: "channel C reversed", nameUkr: "Канал C перевернутий" },
		12: { pos: 12, name: "channel A voltage below normal", nameUkr: "Напруга каналу A нижче норми" },
		13: { pos: 13, name: "channel B voltage below normal", nameUkr: "Напруга каналу B нижче норми" },
		14: { pos: 14, name: "channel C voltage below normal", nameUkr: "Напруга каналу C нижче норми" },
		16: { pos: 16, name: "channel A voltage above normal", nameUkr: "Напруга каналу A вище норми" },
		17: { pos: 17, name: "channel B voltage above normal", nameUkr: "Напруга каналу B вище норми" },
		18: { pos: 18, name: "channel C voltage above normal", nameUkr: "Напруга каналу C вище норми" },
		20: { pos: 20, name: "channel A no voltage", nameUkr: "Немає напруги на каналі A" },
		21: { pos: 21, name: "channel B no voltage", nameUkr: "Немає напруги на каналі B" },
		22: { pos: 22, name: "channel C no voltage", nameUkr: "Немає напруги на каналі C" },
		24: { pos: 24, name: "channel A curency above normal", nameUkr: "Сила струму каналу A вище норми" },
		25: { pos: 25, name: "channel B curency above normal", nameUkr: "Сила струму каналу B вище норми" },
		26: { pos: 26, name: "channel C curency above normal", nameUkr: "Сила струму каналу C вище норми" },
		28: { pos: 28, name: "channel A active power above normal", nameUkr: "Активна потужність каналу A вище норми" },
		29: { pos: 29, name: "channel B active power above normal", nameUkr: "Активна потужність каналу B вище норми" },
		30: { pos: 30, name: "channel C active power above normal", nameUkr: "Активна потужність каналу C вище норми" }
	},

	// Type description 48
	interface_status_bits: {
		0: { pos: 0, name: "Optical port: active authorization at the user level", nameUkr: "Оптичний порт: активна авторизація на рівні користувача" },
		1: { pos: 1, name: "Optical port: active authorization at the operator level", nameUkr: "Оптичний порт: активна авторизація на рівні оператора" },
		2: { pos: 2, name: "Optical port: active authorization at the manufacturer level", nameUkr: "Оптичний порт: активна авторизація на рівні виробника" },
		4: { pos: 4, name: "Optical port: authorization at the user level is locked", nameUkr: "Оптичний порт: авторизація на рівні користувача заблокована" },
		5: { pos: 5, name: "Optical port: authorization at the operator level is locked", nameUkr: "Оптичний порт: авторизація на рівні оператора заблокована" },
		8: { pos: 8, name: "Interface 1: active authorization at the user level", nameUkr: "Інтерфейс 1: активна авторизація на рівні користувача" },
		9: { pos: 9, name: "Interface 1: active authorization at the operator level", nameUkr: "Інтерфейс 1: активна авторизація на рівні оператора" },
		12: { pos: 12, name: "Interface 1: authorization at the user level is locked", nameUkr: "Інтерфейс 1: авторизація на рівні користувача заблокована" },
		13: { pos: 13, name: "Interface 1: authorization at the operator level is locked", nameUkr: "Інтерфейс 1: авторизація на рівні оператора заблокована" },
		16: { pos: 16, name: "Interface 2: active authorization at the user level", nameUkr: "Інтерфейс 2: активна авторизація на рівні користувача" },
		17: { pos: 17, name: "Interface 2: active authorization at the operator level", nameUkr: "Інтерфейс 2: активна авторизація на рівні оператора" },
		20: { pos: 20, name: "Interface 2: authorization at the user level is locked", nameUkr: "Інтерфейс 2: авторизація на рівні користувача заблокована" },
		21: { pos: 21, name: "Interface 2: authorization at the operator level is locked", nameUkr: "Інтерфейс 2: авторизація на рівні оператора заблокована" },
		24: { pos: 24, name: "Interface 3: active authorization at the user level", nameUkr: "Інтерфейс 3: активна авторизація на рівні користувача" },
		25: { pos: 25, name: "Interface 3: active authorization at the operator level", nameUkr: "Інтерфейс 3: активна авторизація на рівні оператора" },
		28: { pos: 28, name: "Interface 3: authorization at the user level is locked", nameUkr: "Інтерфейс 3: авторизація на рівні користувача заблокована" },
		29: { pos: 29, name: "Interface 3: authorization at the operator level is locked", nameUkr: "Інтерфейс 3: авторизація на рівні оператора заблокована" }
	},

	components: {
		TileVidget,
		ElectricMeterReportTable,
		PerformSurveyForm,
	},

	props: {
		stationId: {
			type: String,
			require: true,
		},
	},

	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()

		return {
			accountStore,
			stationsStore,
			numberToKnumber,
			Station,
			ElectricMeter,
			ServiceUnit,
			easyDataTableHeight,
			// easyDataTableRowsPerPage,
			dateTimeToString,
		}
	},

	data() {
		return {
			// For table period from. Hours from now.
			viewDaysFromNow: 1,
			isLoading: true,
			// Table
			rowsPerPage: 20,
			tableHeaders:[
				//{ text: "Час", value: "time", sortable: true, width: 160, },
				{ text: "Параметр", value: "_field" },
				{ text: "Значення", value: "_value" },
			],

			tableRowsSettings: [
				//{ type: 'meter_value',  id: ElectricMeter.metricKeys.model, title: "Тип/модель" },
				//{ type: 'meter_value',  id: ElectricMeter.metricKeys.lastConnection, title: "Час зчитування" },
				{ type: 'title_row', id: 'table_row_instant_values', title: "Миттєві значення", show: true, },
				{ type: 'meter_value',  id: ElectricMeter.metricKeys.fullActiveEnergy, title: "Активна енергія повна, кВт⋅год", show: true, },
				{ type: 'meter_value',  id:"phase_voltage", title: "Напруга фази для 1 Ф", show: true, },
				{ type: 'meter_value',  id:"phase_current", title: "Струм фази для 1 Ф", show: true, },
				{ type: 'meter_value', id: "power_factor", title: "Коефіцієнт потужності", show: true, },
				{ type: 'meter_value',  id:"active_energy_ap", title: "Сумарна по фазам активна потужність А+, КВт", show: true, },
				{ type: 'meter_value',  id:"active_energy_am", title: "Сумарна по фазам активна потужність А-, КВт", show: true, },
				{ type: 'meter_value',  id:"active_energy_ap_p_am", title: "Сумарна по фазам активна потужність |А+|+|А-|, КВт", show: true, },
				{ type: 'meter_value',  id:"active_energy_ap_m_am", title: "Сумарна по фазам активна потужність |А+|-|А-|, КВт", show: true, },
				{ type: 'title_row', id: 'title_row_state', title: "Стан", show: true, },
				{ type: 'meter_value',  id:"meter_status", title: "Стан лічильника", show: true, },
				{ type: 'meter_value',  id:"power_line_status", title: "Стан мережі", show: true, },
				{ type: 'meter_value',  id:"interface_status", title: "Стан інтерфейсів", show: true, },
				{ type: 'meter_value',  id:"battery_voltage", title: "Напруга аккумулятора", show: true, },
				{ type: 'meter_value',  id:"disconnector_state", title: "Поточний стан дисконектора", show: true, },
				{ type: 'title_row', id: 'title_row_energy_by_tarifs', group: 'energy_by_tarifs', title: "Енергії по тарифам", show: true, },
				{
					type: 'meter_values_group',
					// id: '',
					group: 'energy_by_tarifs',
					ids: ['active_energy_ap_1','active_energy_ap_2', 'active_energy_ap_3', 'active_energy_ap_4'],
					title: "Активна енергія А+ по тарифам 1-4, Вт⋅год",
					show: true,
				},
				{
					type: 'meter_values_group',
					group: 'energy_by_tarifs',
					ids: ['active_energy_am_1', 'active_energy_am_2', 'active_energy_am_3', 'active_energy_am_4'],
					title: "Активна енергія А- по тарифам 1-4, Вт⋅год",
					show: true,
				},
				{
					type: 'meter_values_group',
					group: 'energy_by_tarifs',
					ids: [
						`${ElectricMeter.metricKeys.activeEnergyFullApPam}_1`,
						`${ElectricMeter.metricKeys.activeEnergyFullApPam}_2`,
						`${ElectricMeter.metricKeys.activeEnergyFullApPam}_3`,
						`${ElectricMeter.metricKeys.activeEnergyFullApPam}_4`
					],
					title: "Активна енергія повна |А+|+|A-| по тарифам 1-4, Вт⋅год",
					show: true,
				},
				{
					type: 'meter_values_group', 
					group: 'energy_by_tarifs',
					ids:[
						'active_energy_grid_ap_m_am_1','active_energy_grid_ap_m_am_2',
						'active_energy_grid_ap_m_am_3','active_energy_grid_ap_m_am_4'
					],
					title: "Активна енергія мережі |А+|-|A-| по тарифам 1-4, Вт⋅год",
					show: true,
				},
			],
			tableItems: [],
		}
	},

	watch: {
		isPresentActiveEnergyTarifs(newValues) {
			this.tableItems
				.filter((el) => el.group == 'energy_by_tarifs')
				.forEach((el) => el.show = newValues)
		},
	},

	async created() {
		this.$watch(() => this.station.electricMeter.metrics.size, (/*newVal, oldVal*/) => {
			this.fillTableData()
		})

		this.fillTableData()
	},

	mounted() {
		//this.rowsPerPage = easyDataTableRowsPerPage(this.tableHeight)
	},

	methods: {
		fillTableData() {
			let metrics = new Map()
			
			this.isLoading = true

			// Iterate all electric meter metrics. Create parsed metrics Map (id: metric)
			this.station.electricMeter.metrics.forEach(it => {
				metrics.set(
					it.id,
					this.parseMetric(it.id, it.value)
				)
			})
			
			// Clear table
			this.tableItems = []
			// Create table row by row from tableRows array
			this.tableRowsSettings.forEach(rowFormat => {
				let tableItem = new Object()
				tableItem.type = rowFormat.type
				tableItem.show = rowFormat.show
				tableItem.group = rowFormat.group

				switch(rowFormat.type){
					case 'title_row':
						tableItem._field = rowFormat.title
						break
					case 'meter_value':
						tableItem._field = rowFormat.title
						tableItem._value = metrics.has(rowFormat.id) ? metrics.get(rowFormat.id) : "-"
						break
					case 'meter_values_group':
						tableItem._field = rowFormat.title
						tableItem._value = ""//`${metrics.get(row.id)}`
						rowFormat.ids.forEach(id => {
							tableItem._value += (metrics.has(id) ? metrics.get(id).toFixed(0) : "-") + "; "
						})
						// console.log('values', tableItem._value)
				}

				if (tableItem.group == 'energy_by_tarifs') {
					// console.log('isPresentActiveEnergyTarifs = ', this.isPresentActiveEnergyTarifs)
					tableItem.show = this.isPresentActiveEnergyTarifs
				}

				this.tableItems.push(tableItem)
			})
			
			this.isLoading = false
		},

		electricMeterMetric(id) {
			if (!this.station.electricMeter.metrics.has(id)) {
				return "-"
			}

			return this.parseMetric(id, this.station.electricMeter.metrics.get(id).value)
		},

		/*	Parse electric meter metric to user undestendable promt. */
		parseMetric(id, value) {
			switch(id) {
				case Station.passportKeys.electricMeter.lastConnection:
					return dateTimeToString(value, false)
				case 'meter_status': {
					let promt = ""//`${value}; `

					Object.values(this.$options.meter_status_bits).forEach(status => {
						if (value & (1 << status.pos)) {
							promt += status.nameUkr + ";   "
						}
					})

					return promt.length == 0 ? "-" : promt
				}
				case 'power_line_status': {
					let promt = ""//`${value}; `

					Object.values(this.$options.power_line_status_bits).forEach(status => {
						if ('size' in status) {
							const mask = (value >> status.pos) && Math.pow(2, status.size) - 1
							if (value && mask) {
								promt += `${status.nameUkr} ${value && mask}; `
							}
						} else if (value & (1 << status.pos)) {
							promt += status.nameUkr + ";   "
						}
					})

					return promt.length == 0 ? "-" : promt
				}
				case 'interface_status': {
					let promt = ""//`${value}; `

					Object.values(this.$options.interface_status_bits).forEach(status => {
						if (value & (1 << status.pos)) {
							promt += status.nameUkr + ";   "
						}
					})

					return promt.length == 0 ? "-" : promt
				}
				case 'disconnector_state':
					return value ? 'Вкл' : 'Викл'
				default:
					return value
			}
		},

		stationMetricTime(metricName, unit="any") {
			let metric = this.station?.getMetric(metricName, unit)
			
			if (typeof metric == 'object') {
				return metric.time.toLocaleString()
			} else {
				return '-'
			}

		},
	},

	computed: {
		station() {return this.stationsStore.station(this.stationId) },

		isPresentActiveEnergyTarifs() {
			return this.station.electricMeter.isPresentActiveEnergyTarifs
		},

		tableRows() {
			return this.tableItems.filter((el) => el.show)
		},

		tableHeight() {
			return easyDataTableHeight() - 114 - (this.isPresentActiveEnergyTarifs ? 0 : 190)
		},

		electricMeterType() {
			return this.station.passport.get(Station.passportKeys.electricMeter.self)[Station.passportKeys.electricMeter.type]
		},

		electricMeterConnection() {
			switch(this.electricMeterType) {
				case ElectricMeter.versions.impulseInput:
					return this.station?.service_unit.isConnect
				case ElectricMeter.versions.nikDlms:
				case ElectricMeter.versions.gama100G1b:
				case ElectricMeter.versions.gama100G1m:
					return this.station?.electricMeter.isConnect
				default:
					return undefined
			}
			
		},

		fullActiveEnergy() {
			switch(this.electricMeterType) {
				case ElectricMeter.versions.nikDlms:
				case ElectricMeter.versions.gama100G1m:
				case ElectricMeter.versions.gama100G1b: {
					const value = this.station.electricMeter.getMetricValue(
						ElectricMeter.metricKeys.fullActiveEnergy, 2
					)

					if (value == '') {
						return '-'
					} else {
						return `${value}\xa0кВт⋅год`
					}
				}
				case ElectricMeter.versions.impulseInput: {
					let value = this.station.getFormatedMetric(
						ServiceUnit.metricKeys.extPwrCounterEnergy,
						'service'
					)
				
					if (value) {
						value = Number(value).toFixed(2)
					} else {
						value = '-'
					}
					return `${value}\xa0кВт⋅год`
				}
				default:
					return `-`
				
			}
		},
	},
}
</script>


<style src="@/assets/widget.css" scoped></style>
<style src="@/assets/table.css" scoped></style>
<style scoped>
</style>